import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import BalletBoxIcon from '@nv/images/design/ballet-box-icon'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmArchiveEvent.module.scss'

export const ConfirmArchiveEvent = ({ confirm }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('Confirm Achive Event'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.confirm'), onClick: confirm },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <BalletBoxIcon />
      <span>{t('Are you sure you want to archive this event?')}</span>
    </div>
  )
}
